import { IActionType, IMiddlewareNext, IMiddlewareStore } from '../../../common/common.types'
import { runRule, setDispatchedActions } from '../store/rules.actions'

export const rulesMiddleware =
  <T extends IActionType>(store: IMiddlewareStore) =>
    (next: IMiddlewareNext<T>) =>
      (action: T): void => {
        next(action)
        const { indexedStandardRules, indexedXsdRules } = store.getState().options.rulesOptions
        const allIndexedRules = { ...indexedStandardRules, ...indexedXsdRules }

        const dispatchedActions = store.getState().rules.dispatchedActions
        const isAlreadyInQueueFlag = dispatchedActions.find((a) => (a === action.type))

        if (allIndexedRules[action.type] && !isAlreadyInQueueFlag) {
          store.dispatch(setDispatchedActions([...dispatchedActions, action.type]))

          const shouldRunRule = allIndexedRules[action.type].some(rule => rule.triggerOnStateChangeFlag)

          if (shouldRunRule) {
            store.dispatch(runRule())
          }
        }
      }
